import { ApiType } from "@gymflow/common";
import { SubscriptionPromotionSummary } from "@gymflow/types";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { memberQueryKeys } from "./memberQueryKeys";

export function useQueryAddPromotionCodeToSubscriptionSummary(
  {
    api,
    subscriptionId,
    promotionCode,
  }: {
    api: ApiType;
    subscriptionId?: number;
    promotionCode?: string;
  },
  queryOpts?: Omit<
    UseQueryOptions<unknown, unknown, SubscriptionPromotionSummary>,
    "queryKey"
  >,
) {
  return useQuery({
    queryKey: memberQueryKeys.addPromotionCodeToSubscription({
      subscriptionId,
      promotionCode,
    }),
    queryFn: async () => {
      const response =
        await api.memberApi.addPromotionCodeToSubscriptionSummary({
          subscriptionId: subscriptionId as number,
          promotionCode: promotionCode as string,
        });
      return response.data;
    },
    enabled: !!subscriptionId && !!promotionCode,
    ...queryOpts,
  });
}
